<script lang="ts">import Section from '../Section/Section.svelte';
import TextStack from '../TextStack/TextStack.svelte';
const { variant = 'overview', colorMode = 'light', eyebrow = '', heading = '', subheading = '', background: backgroundFromProps, content, ctaItems: ctaItemsFromProps, class: className = '', ...rest } = $props();
const textStackProps = $derived({
    eyebrowText: eyebrow,
    eyebrowVariant: 'hero',
    isEyebrowInHeading: true,
    headingText: heading,
    headingLevel: 'h1',
    headingVariant: variant === 'secondary' ? '900' : '1000',
    bodyText: subheading,
    alignment: variant === 'secondary' ? 'left' : 'center',
});
</script>

<Section {...rest} class="Hero Hero--{variant} {className}" {colorMode} paddingTop="40" paddingBottom="80">
  {#if ctaItemsFromProps}
    <TextStack {...textStackProps}>
      {#snippet ctaItems()}
        {@render ctaItemsFromProps?.()}
      {/snippet}
    </TextStack>
  {:else}
    <TextStack {...textStackProps} />
  {/if}

  {#if content}
    <div class="Hero__content">
      {@render content?.()}
    </div>
  {/if}

  {#snippet background()}
    {#if backgroundFromProps}
      <div class="Hero__background">
        {@render backgroundFromProps?.()}
      </div>
    {/if}
  {/snippet}
</Section>

<style>/**
 * Do not edit directly, this file was auto-generated.
 * Fri, 01 Aug 2025 11:58:03 GMT
 */
/**
 We use rem units for media queries to promote accessible layouts. By utilizing rem units, the computed values in media queries are determined by the user's browser-defined font size rather than our global 'font-size: 62.5%' reset. This approach ensures that our design adapts to individual user settings, enhancing accessibility. 
 */
/**
  * Calculates the total width of a specified number of grid columns including gaps.
  * @function width-of-columns
  * @param {number} $n - The number of columns.
  * @param {number} $out-of - The total number of columns in the grid layout (default is 12).
  * @return {string} The calculated width with the unit.
  * 
  * The calculation considers the width of a column and the gaps between columns.
  * It subtracts the total number of gaps from the container width and calculates
  * the width for the specified number of columns.
  */
@layer design-system-components.pwds {
  :global(.Hero) {
    overflow: hidden;
  }
  :global(.Hero) :global(.TextStack__text) {
    text-wrap: pretty;
    max-width: var(--hero-subheading-max-width);
  }
  :global(.Hero) :global(.Action--anchor.Action--regular),
  :global(.Hero) :global(.Action--anchor.Action--regular) :global(.Action__content-wrapper) {
    --action-variant-button-min-width: var(--action-variant-button-size-regular-min-width);
    --action-variant-button-padding: var(--action-variant-button-size-regular-padding);
    --action-variant-button-font-size: var(--action-size-regular-font-size);
  }
  :global(.Hero) :global(.Action--anchor.Action--large),
  :global(.Hero) :global(.Action--anchor.Action--large) :global(.Action__content-wrapper) {
    --action-variant-button-min-width: var(--action-variant-button-size-large-min-width);
    --action-variant-button-padding: var(--action-variant-button-size-large-padding);
    --action-variant-button-font-size: var(--action-size-large-font-size);
  }
  :global(.Hero.Hero--overview) :global(.TextStack__wrapper) {
    width: 100%;
    display: grid;
    gap: var(--grid-container-gap);
    grid-template-columns: repeat(var(--grid-container-columns), 1fr);
    justify-items: center;
  }
  :global(.Hero.Hero--overview) :global(.TextStack__wrapper) > :global(*) {
    grid-column: 1/-1;
  }
  @media (min-width: 64rem) {
    :global(.Hero.Hero--overview) :global(.TextStack__title) {
      grid-column: 2/span 10;
    }
  }
  @media (min-width: 105rem) {
    :global(.Hero.Hero--secondary) :global(.TextStack) {
      flex-direction: row;
      justify-content: space-between;
      align-items: flex-end;
      gap: var(--space-60);
    }
    :global(.Hero.Hero--secondary) :global(.TextStack__wrapper) {
      flex: 1 1 min-content;
      max-width: calc(8 * calc((var(--container-width-current) - 11 * var(--grid-container-gap)) / 12) + 7 * var(--grid-container-gap));
    }
    :global(.Hero.Hero--secondary) :global(.TextStack__links) {
      flex: 0 0 max-content;
    }
  }
  .Hero__content {
    margin-top: var(--hero-content-margin-top);
    border-radius: var(--container-border-radius);
    overflow: hidden;
  }
  .Hero__background {
    position: relative;
  }
  .Hero__background::after {
    content: "";
    position: absolute;
    bottom: 0;
    width: 100%;
    height: 50%;
    background: linear-gradient(0deg, #fff 28.5%, rgba(255, 255, 255, 0) 88.5%);
  }
}</style>
